import './utils/polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/styles.css';
import DefaultTheme from "./components/DefaultTheme";
import { BrowserRouter } from "react-router-dom";
import { App } from './App';
import { applyCssVars } from './theme/palette';

// Must run before the first render so styles.css never resolves a missing var.
applyCssVars();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <DefaultTheme>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </DefaultTheme>
);
